var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-1b2ff9de-2297-43b1-ae4d-230f34e7ccbd",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .uuid-e2876e1b-de54-4b3d-b8cf-4b2a75607e99 {\r\n        fill: #f74f56;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-e2876e1b-de54-4b3d-b8cf-4b2a75607e99",
    d: "M767.58,406.45l-218.49-141.61c-.16-.1-.34-.13-.5-.23-1.59-.98-3.32-1.75-5.13-2.34-.52-.17-1.02-.35-1.55-.48-1.92-.49-3.9-.83-5.97-.83-.02,0-.04,0-.06,0-.27,0-.53.07-.8.08-1.87.07-3.67.37-5.4.84-.53.15-1.04.31-1.57.49-2.03.7-3.98,1.57-5.73,2.76l-210.32,141.56c-11.07,7.44-14,22.46-6.56,33.53,7.46,11.06,22.47,13.98,33.53,6.54l172.76-116.27v464.42c0,13.34,10.81,24.15,24.15,24.15s24.15-10.82,24.15-24.15v-465.36l181.19,117.44c4.06,2.63,8.62,3.88,13.12,3.88,7.92,0,15.67-3.88,20.29-11.02,7.26-11.18,4.07-26.15-7.13-33.4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-e2876e1b-de54-4b3d-b8cf-4b2a75607e99",
    d: "M540,1080C242.24,1080,0,837.76,0,539.99S242.24,0,540,0s540,242.24,540,539.99-242.24,540.01-540,540.01ZM540,48.31c-271.12,0-491.69,220.57-491.69,491.68s220.57,491.7,491.69,491.7,491.69-220.57,491.69-491.7S811.12,48.31,540,48.31Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropArrow);
export default __webpack_public_path__ + "static/media/DropArrow.aecd95f5c28e84849f9a097a2957c303.svg";
export { ForwardRef as ReactComponent };